module.exports = __webpack_public_path__ + "img/download-app.90621d59.svg";